import { render, staticRenderFns } from "./EmbedWidget.vue?vue&type=template&id=090d6362"
import script from "./EmbedWidget.vue?vue&type=script&lang=js"
export * from "./EmbedWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports